export default {
  default: 'YYYY-MM-DD',
  standardDate: 'Do MMM YYYY',
  sidebar: 'ddd, Do MMM YYYY',
  editStay: 'ddd, MMMM D',
  roomRateCancellationDeadline: 'MMM Do',
}


// WEBPACK FOOTER //
// ./src/utilities/dates/dateFormats.js